<template>
  <div
    class="f-modal f-modal-backdrop"
    :class="{ pointer: backdropClose }"
    @mousedown.left="backdropClose && $emit('close')"
  >
    <div @mousedown.left.stop="">
      <f-dialog
        @close="$emit('close')"
        :title2="title2"
        :pending="pending"
        :closable="closable"
      >
        <template #title2>
          <slot name="title2" v-if="$slots.title2">
          </slot>
          <span v-else>{{ $vt(title2) }}</span>
        </template>
        <template #content>
          <slot name="content"></slot>
        </template>
        <template #actions>
          <slot name="actions"></slot>
        </template>
      </f-dialog>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
export default {
  props: {
    backdropClose: Boolean,
    show: Boolean,
    title2: String,
    pending: Boolean,
    closable: Boolean,
  },
  methods: {
    keyUp(event) {
      if (event.which === 27) {
        this.$emit("close");
      }
    },
  },
  mounted() {
    window.addEventListener("keyup", this.keyUp);
  },
  unmounted() {
    window.removeEventListener("keyup", this.keyUp);
  },
};
</script>


<style lang="scss">
.f-modal-backdrop {
  position: fixed;
  z-index: 1000; // Juste pour que les notifs passent au dessus

  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background: rgba(22, 22, 21, 0.25);
  backdrop-filter: blur(1px);

  display: flex;
  align-items: center;
  justify-content: center;
}

.f-dialog {
  cursor: initial;
}

.f-modal-backdrop.pointer {
  cursor: pointer;
}

.dark-mode {
  .f-modal-backdrop {
    backdrop-filter: blur(1px);
    background: var(--white-a5);
  }
}
</style>